// Handles Routing and Layout

import React, { ReactNode, useState } from 'react';
import { Typography, CardMedia, Avatar } from '@mui/material';
import { AppBar, Toolbar, Box } from '@mui/material';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import Menu from '../Menus/Menu.jsx';
import { Link } from '@mui/material';           // MUI Link
import { Link as RouterLink } from 'react-router-dom';
import AccountStatusIcon from '../../pages/AccountProfile/AccountStatusIcon.jsx';
import AccountCircle from '@mui/icons-material/AccountCircle';
// import logo192 from '../../assets/images/logo192.png'
// import logo192 from '/favicons/favicon-256.png'
// import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useAuth } from '../../pages/Authentication/AuthContext.jsx';
import { Icon } from 'lucide-react';
// import { Home as HomeIcon } from '@mui/icons-material/Home';
// import { APP_VERSION, BUILD_NUMBER } from '../../config.js';

interface WrapperProps {
  icon: ReactNode; // Accepts <MenuIcon />, <p>Menu</p>, strings, etc.
}

const IconWrapper = ({ icon }: WrapperProps) => {
  return <div className="icon-container">{icon}</div>;
};

function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [legalMenuOpenX, setLegalMenuOpenX] = useState(false);
    const { currentUser, userProfile } = useAuth();


    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const toggleMenu = () => {
        console.log('toggleMenu called. Current menuOpen state:', menuOpen);
        setMenuOpen(!menuOpen);
        if (!menuOpen) {
            setLegalMenuOpenX(false);
        }
    };

    const handleLegalMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setLegalMenuOpenX(!legalMenuOpenX);
    };


    const drawerWidth = 320;
    const drawerHeight = 500;


    const drawer = (
        <Box onClick={ toggleMenu } sx={{ textAlign: 'center', width: drawerWidth, height: drawerHeight, marginTop: '1rem', marginBottom: '1.5rem' }}>
        {/* <Box onClick={ toggleDrawerWidth } sx={{ textAlign: 'center', width: drawerWidth, height: drawerHeight, marginTop: '1rem', marginBottom: '1.5rem' }}> */}
            <Link component={RouterLink} to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                    
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', height: 48, marginLeft: '1rem' }}>
                    <CardMedia
                        component="img"
                        image="/favicons/favicon-256.png" // 👈 Pass the public folder string path directly here
                        alt="logo"
                        sx={{
                            width: 48,
                            height: 48,
                            alignSelf: 'center',
                            borderRadius: '50%',
                            marginRight: 2,
                            marginTop: 0,
                            marginBottom: 2,
                        }}
                    />
                    <Typography variant="h6" sx = {{ mb: 2, mx: 0  }}>
                        mobidawg
                    </Typography>
                </Box>
            </Link>
                
            <Divider />

            <Menu toggleMenu={
                    toggleMenu
            }/>

            {/* <Menu toggleMenu={handleLegalMenuClick}/> */}

        </Box>
    );

    console.log('mobidawg IconButton type:', typeof IconButton);
    console.log('mobidawg MenuIcon type:', typeof MenuIcon, MenuIcon.name);
    console.log('mobidawg HomeIcon type:', typeof HomeIcon, HomeIcon.name);
    console.log('Raw Import:', MenuIcon);

    const ActualMenuIcon = (MenuIcon as any).default || MenuIcon;
    const ActualHomeIcon = (HomeIcon as any).default || HomeIcon;
    const ActualAccountCircle = (AccountCircle as any).default || AccountCircle;    

    console.log('mobidawg ActualIcon type:', typeof ActualMenuIcon, ActualMenuIcon.name);
    
    return (
        <>
            <AppBar position="fixed" sx={{  width: '100%', 
                    marginLeft: isSmallScreen ? 0 : drawerWidth, 
                    backgroundImage: 'linear-gradient(to top,rgb(110, 76, 21) 7%,  #A0522D 37%,  #A0522D 29%, white )' }}>
                <Toolbar>
                    {/* Content for your toolbar */}

                    {isSmallScreen && ( // Show menu icon only on small screens

                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 0 }}
                            onClick = {toggleMenu}
                        >
                            <ActualMenuIcon />
                        </IconButton>
                    )}

                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 0 }}
                            component={RouterLink} to="/"
                        >
                            <ActualHomeIcon />
                        </IconButton>

                        <Typography variant="h6" sx={{ flexGrow: 1 }}>
                            {!isSmallScreen &&
                                <>mobidawg</>
                            }
                        </Typography>

                    {currentUser && userProfile ? (
                        <IconButton component={RouterLink} to="/account" color="inherit">
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'white' }}>{
                                userProfile.photoURL ? (
                                    <Avatar src={userProfile.photoURL} sx={{ width: 24, height: 24 }} />
                                ) : (
                                    // <AccountCircle />
                                    // <p>C</p>
                                    <ActualAccountCircle />
                                )}
                                <Typography variant="caption" sx={{ fontSize: '0.6rem', lineHeight: 1, mt: 1, color: 'white' }}>
                                    {currentUser.email}
                                </Typography>
                            </Box>
                        </IconButton>
                    ) : (
                        <AccountStatusIcon />
                    )}

                </Toolbar>
            </AppBar>

                <Drawer  // Your Drawer component
                    anchor="left"
                    open={isSmallScreen ? menuOpen : true}  // Open state logic
                    onClose={toggleMenu}
                    variant={isSmallScreen ? "temporary" : "permanent"}
                    sx={{
                        width: drawerWidth, // Provide width for permanent drawer
                        flexShrink: 0,      // Prevent shrinking
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                        },
                    }}
                >

                    {drawer}

                </Drawer>
        </>
    );
}

export default Header;
